import envelopeTurquoise from '../../../assets/icons/envelope-turquoise.svg'
import envelopeOrange from '../../../assets/icons/envelope-orange.svg'

export const notificationTypes = {
  COMMON: {
    avatar: envelopeTurquoise,
    color: '#01878E',
    backgroundColor: '#E0F8F9',
    type: 'Comunicado geral'
  },
  OFFICIAL: {
    avatar: envelopeOrange,
    color: '#E67500',
    backgroundColor: '#FFDAB3',
    type: 'Comunicado oficial'
  }
}

export const INITIAL_SKIP = 0
export const INITIAL_PAGE = 1
export const SKIP = 0
export const LIMIT = 5
